import { useCallback, useRef, useState } from "react";

export const useCopyToClipboard = ({ resetAfter = 1500 } = {}) => {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);

  const copy = useCallback(
    async (text = "") => {
      // clear any running timer
      if (timerRef.current) clearTimeout(timerRef.current);

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          // HTTP fallback
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand("copy");
          ta.remove();
        }
        setCopied(true);
        timerRef.current = setTimeout(() => setCopied(false), resetAfter);
      } catch (e) {
        console.error("Copy failed:", e);
        setCopied(false);
      }
    },
    [resetAfter]
  );

  return { copied, copy };
};
